import type { TableShape } from '../../../types';

export function RoundPreview({ selected }: { selected: boolean }) {
  return (
    <svg viewBox="0 0 80 80" className="w-12 h-12">
      <circle cx={40} cy={40} r={22} fill="#f5f0eb" stroke={selected ? '#a68a5b' : '#c9b99a'} strokeWidth={selected ? 2 : 1.5} />
      {Array.from({ length: 6 }, (_, i) => {
        const a = (Math.PI * 2 / 6) * i - Math.PI / 2;
        return <circle key={i} cx={40 + 31 * Math.cos(a)} cy={40 + 31 * Math.sin(a)} r={6} fill={selected ? '#a68a5b' : '#e0d5c5'} stroke="#c9b99a" strokeWidth={1} />;
      })}
    </svg>
  );
}

export function RectPreview({ selected }: { selected: boolean }) {
  return (
    <svg viewBox="0 0 80 60" className="w-12 h-12">
      <rect x={10} y={16} width={60} height={28} rx={3} fill="#f5f0eb" stroke={selected ? '#a68a5b' : '#c9b99a'} strokeWidth={selected ? 2 : 1.5} />
      {[16, 34, 52, 70].map((x, i) => (
        <g key={i}>
          <circle cx={x - 2} cy={8} r={5} fill={selected ? '#a68a5b' : '#e0d5c5'} stroke="#c9b99a" strokeWidth={1} />
          <circle cx={x - 2} cy={52} r={5} fill={selected ? '#a68a5b' : '#e0d5c5'} stroke="#c9b99a" strokeWidth={1} />
        </g>
      ))}
    </svg>
  );
}

export function SquarePreview({ selected }: { selected: boolean }) {
  return (
    <svg viewBox="0 0 70 70" className="w-12 h-12">
      <rect x={14} y={14} width={42} height={42} rx={3} fill="#f5f0eb" stroke={selected ? '#a68a5b' : '#c9b99a'} strokeWidth={selected ? 2 : 1.5} />
      {[24, 46].map((pos, i) => (
        <g key={i}>
          <circle cx={pos} cy={6} r={5} fill={selected ? '#a68a5b' : '#e0d5c5'} stroke="#c9b99a" strokeWidth={1} />
          <circle cx={pos} cy={64} r={5} fill={selected ? '#a68a5b' : '#e0d5c5'} stroke="#c9b99a" strokeWidth={1} />
          <circle cx={6} cy={pos} r={5} fill={selected ? '#a68a5b' : '#e0d5c5'} stroke="#c9b99a" strokeWidth={1} />
          <circle cx={64} cy={pos} r={5} fill={selected ? '#a68a5b' : '#e0d5c5'} stroke="#c9b99a" strokeWidth={1} />
        </g>
      ))}
    </svg>
  );
}

export const SHAPE_OPTIONS: { value: TableShape; label: string; description: string }[] = [
  { value: 'round',       label: 'Round',       description: 'Circular' },
  { value: 'rectangular', label: 'Rectangular', description: 'Banquet' },
  { value: 'square',      label: 'Square',      description: 'Square' },
];
